import React, { useContext } from 'react'
import { Box, Dialog } from '@mui/material'

import LanguageContext from '../../contexts/LanguageContext'
import { useTexte } from "../../contexts/FormeAdresseContext"
import closeIcon from '../../images/closeIcon.svg'

/* ⛔ « CERTIFICATION NON DISPONIBLE » (06/10/2026, demande de Nawal).
   Un seul message, deux presentations : une fenetre quand on clique l'onglet
   grise du menu, un bloc dans la page quand on arrive directement sur
   `/myCertification`. Les deux lisent les MEMES libelles.
   On est en B2B2C : l'apprenant n'a rien souscrit lui-meme. Jamais « votre
   plan », « votre abonnement », ni d'invitation a « passer a l'offre
   superieure ». */

/* Le cadenas de la plateforme : le trace de `images/lockedIcon.svg` (celui des
   espaces verrouilles de l'espace client), repeint a la couleur du texte
   (`currentColor`) pour prendre le gris de l'onglet desactive. */
export const IconeCadenas = ({ taille = 11, style }) => (
  <svg
    width={taille * 19 / 25}
    height={taille}
    viewBox="0 0 19 25"
    fill="none"
    aria-hidden="true"
    focusable="false"
    style={{ display: 'block', flexShrink: 0, ...style }}
  >
    <path fill="currentColor" d="M9.0409 0C5.00962 0 1.72981 3.27968 1.72981 7.31109V11.4866C1.72981 11.5341 1.67125 11.614 1.62526 11.6293C1.2299 11.7612 0.908809 11.8754 0.614884 11.9887C0.26437 12.1239 0 12.5123 0 12.8923V22.4866C0 22.864 0.262662 23.2528 0.610955 23.3908C3.30578 24.4587 6.14201 25 9.04085 25C11.9397 25 14.7759 24.4585 17.4709 23.3907C17.819 23.2527 18.0816 22.864 18.0816 22.4866V12.8923C18.0816 12.5123 17.8173 12.1239 17.4666 11.9886C17.1725 11.8753 16.8515 11.761 16.4564 11.6292C16.4105 11.6139 16.352 11.5339 16.352 11.4865V7.31096C16.3518 3.27968 13.0722 0 9.0409 0ZM7.04954 15.8144C7.04954 14.7138 7.94109 13.8232 9.04077 13.8232C10.1404 13.8232 11.0319 14.7137 11.0319 15.8144C11.0319 16.5437 10.6207 17.1542 10.0363 17.5003V20.7924C10.0363 21.3428 9.59103 21.788 9.04072 21.788C8.49037 21.788 8.04513 21.3428 8.04513 20.7924V17.5003C7.46083 17.1542 7.04954 16.5437 7.04954 15.8144ZM13.838 7.31096V10.9137C12.2649 10.5752 10.6509 10.4037 9.04154 10.4036C7.43285 10.4036 5.81926 10.5751 4.24367 10.9133V7.31096C4.24367 4.66577 6.39562 2.51386 9.04077 2.51386C11.6859 2.51382 13.838 4.66577 13.838 7.31096Z" />
  </svg>
)

const Contenu = ({ idTitre }) => {
  const { actLanguage, languageValues } = useContext(LanguageContext)
  /* Tutoiement / vouvoiement selon la cible du module (07/10/2026,
     contexts/FormeAdresseContext.js). */
  const t = useTexte()
  const titre = t(languageValues?.myCertif?.nonDisponibleTitre)
  const texte = t(languageValues?.myCertif?.nonDisponibleTexte)
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: ['12px', '14px', '14px', '16px'] }}>
      <Box sx={{ color: '#8A8480' }}>
        <IconeCadenas taille={22} />
      </Box>
      <Box id={idTitre} sx={{
        color: 'text.black',
        fontSize: ['22px', '24px', '26px', '28px'],
        lineHeight: 1.25,
        letterSpacing: '-0.02em',
      }}>
        {titre}
      </Box>
      <Box sx={{
        color: 'text.subTitle',
        fontSize: ['15px', '16px', '17px', '18px'],
        lineHeight: 1.5,
      }}>
        {texte}
      </Box>
    </Box>
  )
}

/* Le bloc de la page, a la place du contenu. */
export const MessageCertificationNonDisponible = () => (
  <Box
    role="status"
    data-certification-non-disponible
    sx={{
      maxWidth: '640px',
      boxSizing: 'border-box',
      background: 'white',
      border: '1px solid #E7E7E7',
      padding: ['25px 20px', '35px 35px', '40px 40px', '45px 45px'],
    }}
  >
    <Contenu />
  </Box>
)

/* La fenetre ouverte par l'onglet grise. Coins carres, sans ombre lourde,
   comme les autres fenetres de l'apprenant (MyModal). On ne reprend pas
   MyModal lui-meme : en telephone il ouvre un tiroir PLEINE HAUTEUR, demesure
   pour deux lignes. */
export const FenetreCertificationNonDisponible = ({ ouverte, onFermer }) => {
  const { actLanguage, languageValues } = useContext(LanguageContext)
  return (
    <Dialog
      open={!!ouverte}
      onClose={onFermer}
      maxWidth="xs"
      fullWidth
      aria-labelledby="titre-certification-non-disponible"
      PaperProps={{
        'data-certification-non-disponible': true,
        sx: {
          borderRadius: '0px',
          margin: ['16px', '32px'],
          width: ['calc(100% - 32px)', 'calc(100% - 64px)'],
        },
      }}
    >
      <Box sx={{ position: 'relative', padding: ['28px 22px 26px', '34px 32px 32px'] }}>
        <Box
          component="button"
          type="button"
          onClick={onFermer}
          aria-label={languageValues?.close?.[actLanguage]}
          sx={{
            position: 'absolute', top: ['14px', '16px'], right: ['14px', '16px'],
            width: '32px', height: '32px', padding: '8px', margin: 0,
            border: 0, background: 'transparent', cursor: 'pointer',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
          }}
        >
          <img src={closeIcon} alt="" style={{ width: '16px', height: '16px', display: 'block' }} />
        </Box>
        <Contenu idTitre="titre-certification-non-disponible" />
      </Box>
    </Dialog>
  )
}
